export default __webpack_public_path__ + "static/media/skills.50df3ae0.jpg";